import { render, staticRenderFns } from "./ProjectFullLayout.vue?vue&type=template&id=cdb130be&scoped=true"
import script from "./ProjectFullLayout.vue?vue&type=script&lang=js"
export * from "./ProjectFullLayout.vue?vue&type=script&lang=js"
import style0 from "./ProjectFullLayout.vue?vue&type=style&index=0&id=cdb130be&prod&lang=scss"
import style1 from "./ProjectFullLayout.vue?vue&type=style&index=1&id=cdb130be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdb130be",
  null
  
)

export default component.exports